import React from 'react';
import './BooksPage.css';

// Use production URL for download and Google Docs viewer (needs publicly accessible URL)
const CATALOG_PDF = 'https://vedantacentercharlotte.org/images/Vedanta-Center-of-Charlotte-Book-Store-Library-v1.pdf';
const CATALOG_VIEWER =
  'https://docs.google.com/viewer?url=https://vedantacentercharlotte.org/images/Vedanta-Center-of-Charlotte-Book-Store-Library-v1.pdf&embedded=true';

export default function BooksPage() {
  return (
    <div className="books-page">
      <div className="books-panel">
        <h2>
          <u>To order books please contact: Santu Mandal +1 617-750-6497</u>
        </h2>
    {/*
        <h3>
          <u>Android Users:</u> If you are having trouble viewing our BookStore, please use the link
          below to download the catalog and use the{' '}
          <a
            href="https://play.google.com/store/apps/details?id=com.adobe.reader"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acrobat PDF reader app
          </a>{' '}
          to view it.
        </h3>
        <h3>
          <u>iPhone Users:</u> If you are having trouble viewing our BookStore, please use the link
          below to download the catalog and use the{' '}
          <a
            href="https://apps.apple.com/us/app/adobe-acrobat-reader-edit-pdf/id469337564"
            target="_blank"
            rel="noopener noreferrer"
          >
            Adobe Acrobat Reader app
          </a>{' '}
          to view it.
        </h3>
        <h3>
          <a href={CATALOG_PDF} download>
            Download Our Books Catalog
          </a>
        </h3>
       */} 

        <div className="books-viewer">
          <iframe
            title="Vedanta Center Charlotte Book Store Catalog"
            src={CATALOG_VIEWER}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
